import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export interface HelpTooltipProps {
  /** Tooltip body. String or ReactNode. */
  title: React.ReactNode;
  /** MUI Tooltip placement. Defaults to 'top'. */
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end';
  /**
   * Required aria-label for the icon button — every caller must localize this.
   * Intentionally required so callers can never omit it (accessibility cliff).
   */
  ariaLabel: string;
  /** Optional icon size override. Defaults to 'small'. */
  fontSize?: 'inherit' | 'small' | 'medium' | 'large';
}

export default function HelpTooltip({
  title,
  placement = 'top',
  ariaLabel,
  fontSize = 'small',
}: HelpTooltipProps): React.ReactElement {
  return (
    <Tooltip title={title} placement={placement} arrow>
      {/* IconButton makes the tooltip keyboard-reachable; MUI handles focus/hover both. */}
      <IconButton size="small" aria-label={ariaLabel}>
        <InfoOutlinedIcon fontSize={fontSize} />
      </IconButton>
    </Tooltip>
  );
}
